import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

class AppInfoService {
    public async getAppInfo(): Promise<any> {
        const response = await http.get(Routes.AppInfoRoutes.GetAppInfo());
        return response.data;
    }
}

export default new AppInfoService();
